/* eslint-disable no-param-reassign */

/**
 *
 * @param {[{adults: number, children: number[]}]} occupancy
 * @param {{minOccupancy: number,
 * maxOccupancy: number,
 * minChildAge: number,
 * maxChildAge: number,
 * childrenEnabled: boolean}} checkingParams
 * @returns {boolean} If occupancy should be checked for some of the keys in checkingParams
 */
const isInvalidOccupancy = (occupancy, checkingParams) => {
    const {
        minOccupancy,
        maxOccupancy,
        minChildAge,
        maxChildAge,
        childrenEnabled,
    } = checkingParams;
    const shouldReplaceAdults = minOccupancy && minOccupancy <= maxOccupancy;
    const shouldAdjustOccupancy = occupancy.some(
        (innerOccupancy) => {
            const childAgeInvalid = innerOccupancy.children?.some(
                childAge => (childAge < minChildAge || childAge > maxChildAge),
            );

            const maxOccupancyReached = (innerOccupancy.adults + innerOccupancy.children?.length) > maxOccupancy;

            return childAgeInvalid || maxOccupancyReached;
        },
    );

    return shouldReplaceAdults || !childrenEnabled || shouldAdjustOccupancy;
};

/**
 *
 * @param {[{adults: number, children: number[]}]} toProcessOccupancy
 * @param {{minOccupancy: number,
 * maxOccupancy: number,
 * minChildAge: number,
 * maxChildAge: number,
 * childrenEnabled: boolean}} checkingParams
 * @returns {[{adults: number, children: number[]}]} The occupancy processed by the params in checkingParams
 */
const sanitizeOccupancy = (toProcessOccupancy, checkingParams) => {
    const {
        childrenEnabled,
        minOccupancy,
        maxOccupancy,
        minChildAge,
        maxChildAge,
    } = checkingParams;
    return toProcessOccupancy.map((occupancy) => {
        let maxOccupancyReached = (occupancy.adults + occupancy.children?.length) > maxOccupancy;

        if (maxOccupancyReached) {
            // Should limit either children or adults,to fit maxOccupancy
            if (occupancy.adults > maxOccupancy) {
                occupancy.adults = maxOccupancy;
            } else {
                // Should process children to balance the occupancy
                while (maxOccupancyReached) {
                    occupancy.children.pop();
                    maxOccupancyReached = (occupancy.adults + occupancy.children?.length) > maxOccupancy;
                }
            }
        }

        if (occupancy.adults < minOccupancy) {
            occupancy.adults = minOccupancy;
        }

        if (!childrenEnabled) {
            occupancy.children = [];
        } else {
            occupancy.children = occupancy.children ? occupancy.children.map((childAge) => {
                if (childAge < minChildAge) {
                    return minChildAge;
                }

                if (childAge > maxChildAge) {
                    return maxChildAge;
                }

                return childAge;
            }) : [];
        }
        return occupancy;
    });
};

export { isInvalidOccupancy, sanitizeOccupancy };
